import { mainLocator as locator } from "@core/di/main.locator";
import { UiService } from "@core/services/ui.services";

import CompanyRepository from "./company.repository";
import { CompanyStore } from "./company.store";

locator.register("CompanyRepository", CompanyRepository);
locator.registerInstance(
  "CompanyStore",
  new CompanyStore(
    locator.resolve<UiService>("UiService"),
    locator.resolve<CompanyRepository>("CompanyRepository"),
  ),
);
